import { registerLocaleData } from '@angular/common';
import localeUk from '@angular/common/locales/uk';
import { initializer } from './services/app.initializer';
import { ClarityIconsService } from './services/clarity-icons.service';
// the second parameter 'fr' is optional
registerLocaleData(localeUk, 'uk');
var ɵ0 = initializer, ɵ1 = function (clarityIconsService) { return function () { return clarityIconsService.addIcons(); }; };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
